interface SectionHeadingProps {
  icon: string;
  kicker: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
}

export default function SectionHeading({
  icon,
  kicker,
  title,
  desc,
  align = "center",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <span
        className={`inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-semibold tracking-wide text-primary-700`}
      >
        <i className={`${icon} text-sm`} aria-hidden="true"></i>
        {kicker}
      </span>
      <h2
        className={`mt-4 text-2xl font-extrabold leading-snug tracking-tight text-foreground-950 md:text-4xl ${
          isCenter ? "" : ""
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
          {desc}
        </p>
      )}
    </div>
  );
}